import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const lpFaqs = [
  { q: "How fast can I start my trademark registration?", a: "You can start immediately! Our streamlined process allows you to begin your trademark registration today with expert guidance every step of the way." },
  { q: "What makes your service different from others?", a: "We combine expert legal guidance with affordable pricing and a proven track record of successful registrations across all industries." },
  { q: "Do I need to have my business registered first?", a: "Not necessarily. We can help you with both trademark registration and business formation, ensuring comprehensive protection for your brand." },
  { q: "What happens after I submit my information?", a: "Our team will review your information and contact you within 24 hours to discuss your trademark needs and next steps." },
  { q: "Can you help with international trademarks?", a: "Yes, we offer comprehensive trademark services including international registration support for businesses looking to protect their brand globally." }
];

export default function LPFAQSection() {
  return (
    <section data-testid="lp-faq-section" className="py-20 md:py-32 bg-[#0D1729]">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-left mb-8">
              <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#D4AF37] mb-4 font-['Outfit']">Quick Questions</p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white font-['Outfit'] tracking-tight">
                Everything You Need to Know
              </h2>
            </div>
            <Accordion type="single" collapsible className="space-y-3">
              {lpFaqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`lp-faq-${i}`}
                  data-testid={`lp-faq-item-${i}`}
                  className="bg-[#121E3D] border border-[#1D2D50] rounded-sm overflow-hidden"
                >
                  <AccordionTrigger className="px-6 py-4 text-left text-white hover:text-[#D4AF37] text-sm font-medium font-['Outfit'] hover:no-underline [&[data-state=open]]:text-[#D4AF37]">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4 text-[#A0AABF] text-sm leading-relaxed">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
          <div className="relative">
            <img
              src="/assets/img/main-faq.jpg"
              alt="FAQ"
              className="w-full h-auto rounded-sm shadow-2xl object-cover"
            />
          </div>
        </div>
        
      </div>
    </section>
  );
}
